<template>
  <v-form ref="form" v-model="isValid">
    <v-text-field
      label="Código"
      v-model="form.code"
      :rules="[rules.required]"
      required
    />

    <v-textarea
      label="Descripción"
      v-model="form.description"
      :rules="[rules.required]"
      required
    />

    <!-- Campo color con diálogo -->
    <v-text-field
      class="mt-4"
      label="Color"
      v-model="form.color"
      readonly
      :rules="[rules.required]"
      required
      @click="colorDialog = true"
    >
      <template v-slot:append>
        <v-avatar size="20" :color="form.color"></v-avatar>
      </template>
    </v-text-field>

    <v-dialog v-model="colorDialog" max-width="320" close>
      <v-card>
        <v-card-title>
          Seleccionar color
          <v-spacer></v-spacer>
          <v-icon @click="resetColor">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text>
          <v-color-picker
            v-model="form.color"
            mode="hexa"
            hide-inputs
            show-swatches
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="colorDialog = false">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-switch label="Activo" v-model="form.active" />

    <div class="mt-4">
      <v-btn color="primary" @click="submit">Guardar</v-btn>
      <v-btn text @click="$emit('cancel')">Cancelar</v-btn>
    </div>
  </v-form>
</template>

<script>
export default {
  props: {
    category: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      isValid: false,
      colorDialog: false,
      form: {
        code: this.category.code || "",
        description: this.category.description || "",
        color: this.category.color || "#262D3C",
        active: this.category.active ?? true
      },
      rules: {
        required: v => !!v || "Campo requerido"
      }
    };
  },
  watch: {
    category: {
      handler(newValue) {
        this.form.code = newValue.code || "";
        this.form.description = newValue.description || "";
        this.form.color = newValue.color || "#262D3C";
        this.form.active = newValue.active ?? true;
      },
      immediate: true
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        const payload = {
          ...this.category,
          ...this.form,
          // se elimina el alfa para que sea compatible con el color
          color:
            this.form.color.length > 7
              ? this.form.color.slice(0, 7)
              : this.form.color,
          code: (this.form.code || "").toUpperCase()
        };

        this.$emit("save", payload);
      }
    },
    resetColor() {
      this.form.color = this.category.color || "#262D3C";
      this.colorDialog = false;
    }
  }
};
</script>
